import { render, staticRenderFns } from "./MultiProject.vue?vue&type=template&id=33b9bbcf"
import script from "./MultiProject.vue?vue&type=script&lang=js"
export * from "./MultiProject.vue?vue&type=script&lang=js"
import style0 from "./MultiProject.vue?vue&type=style&index=0&id=33b9bbcf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports